import React from "react";
import "./Footer.css";
import ic_email from "../images/ic_email.png";
import ic_call from "../images/ic_call.png";
import github from "../images/github.png";
import skype from "../images/skype.png";
import facebook from "../images/facebook.png";
import twitter from "../images/twitter.png";
import linkedin from "../images/linkedin.png";
import { openURL } from "../common/common";

const Footer = () => {
  return (
    <div className="ContainerMain">
      <p className={"GetInTouch h2"}>Get In Touch</p>
      <hr className="h-line" />
      <p style={{ marginTop: 30 }} className={"SubTextStyle h5"}>
        You have an idea?
      </p>
      <p className={"SubTextStyle h5"}>
        I am here to turn your idea into real digital solution .
      </p>
      <div className="m-t-10">
        <img className="m-end-5" src={ic_email} height={20} width={20} />
        <span className="h6 green-color m-end-10"> pardeep352@gmail.com</span>
        <img className="m-end-5" src={ic_call} height={20} width={20} />
        <span className="h6 green-color">9887316421</span>
      </div>
      <div className="footer-icon-container ">
        <img
          className="rounded-circle m-end-5 circle-image-icon"
          src={github}
          style={{ cursor: "pointer" }}
          onClick={()=>{
            openURL('https://github.com/Pradeepkumar2091')
          }}
          width={45}
        />
        <img
          className="rounded-circle m-end-5 circle-image-icon"
          src={linkedin}
          width={45}
          style={{ cursor: "pointer" }}
          onClick={()=>{
            openURL('https://www.linkedin.com/in/pradeep-kumar-067150ba/')
          }}
        />
        <img
          className="rounded-circle m-end-5 circle-image-icon"
          src={facebook}
          width={45}
          style={{ cursor: "pointer" }}
          onClick={()=>{
            openURL('https://www.facebook.com/pardeep0008/')
          }}
        />
        <img
          className="rounded-circle m-end-5 circle-image-icon"
          src={twitter}
          style={{ cursor: "pointer" }}
          width={45}
          onClick={()=>{
            openURL('https://www.twitter.com/pradeep20_91/')
          }}
        />
        <img
          className="rounded-circle m-end-5 circle-image-icon"
          src={skype}
          width={45}
          style={{ cursor: "pointer" }}
          onClick={()=>{
            openURL('https://join.skype.com/invite/w3Sn9ckNyqZ1')
          }}
        />
      </div>
    </div>
  );
};

export default Footer;
